import InfantFruitsAndVegsProduct from 'models/InfantFruitsAndVegsProduct'

export const brandNameOptions = [
  {
    value: '',
    label: 'Brand Name',
    isDisabled: true,
  },
  { value: 'Beech-Nut', label: 'Beech-Nut' },
  { value: 'Early On', label: 'Early On' },
  { value: "Earth's Best Organic", label: "Earth's Best Organic" },
  { value: 'First Choice', label: 'First Choice' },
  { value: 'Gerber', label: 'Gerber' },
  { value: 'Good & Gather Baby', label: 'Good & Gather Baby' },
  { value: 'Happy Baby Organics', label: 'Happy Baby Organics' },
  { value: "Mom's Natural Choice", label: "Mom's Natural Choice" },
  { value: "Mom's Organic Choice", label: "Mom's Organic Choice" },
  { value: 'O Organics', label: 'O Organics' },
  { value: 'Once Upon a Farm', label: 'Once Upon a Farm' },
  { value: "Parent's Choice", label: "Parent's Choice" },
  { value: 'Pic Select Fresh', label: 'Pic Select Fresh' },
  { value: "Raley's Organic", label: "Raley's Organic" },
  { value: 'Simple Truth Organic', label: 'Simple Truth Organic' },
  { value: 'Tippy Toes', label: 'Tippy Toes' },
  { value: 'Tippy Toes Organic', label: 'Tippy Toes Organic' },
  { value: 'Wild Harvest', label: 'Wild Harvest' },
  { value: 'Yummy Naturals', label: 'Yummy Naturals' },
  { value: 'Yummy Organics', label: 'Yummy Organics' },
]

export const packagingInitialState = {
  category: InfantFruitsAndVegsProduct.category,
  subCategory: InfantFruitsAndVegsProduct.subCategory,
  ProductType: {
    value: '',
    label: 'Product Type',
  },
  PackageType: {
    value: '',
    label: 'Package Type',
  },
  PacketSize: '4 ounces only',
  MultiPackageType: false,
  MultiPackageCount: '',
  Organic: false,
  NoAdditionalIngredients: false,
}

export const productTypeOptions = ['Fruit', 'Vegetable', 'Combo']

export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  { value: 'Jar', label: 'Jar' },
  { value: 'Plastic', label: 'Plastic' },
]
